import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPersonApprove = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4 9C4 6.23858 6.23858 4 9 4C11.7614 4 14 6.23858 14 9C14 10.5202 13.3215 11.882 12.2509 12.7991C14.4798 13.97 16 16.3075 16 19C16 19.5523 15.5523 20 15 20C14.4477 20 14 19.5523 14 19C14 16.2386 11.7614 14 9 14C6.23858 14 4 16.2386 4 19C4 19.5523 3.55228 20 3 20C2.44772 20 2 19.5523 2 19C2 16.3075 3.52021 13.97 5.74913 12.7991C4.67847 11.882 4 10.5202 4 9ZM9 6C7.34315 6 6 7.34315 6 9C6 10.6569 7.34315 12 9 12C10.6569 12 12 10.6569 12 9C12 7.34315 10.6569 6 9 6Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M21.69 6.72385C22.0897 6.34279 22.1049 5.70981 21.7239 5.31004C21.3428 4.91027 20.7098 4.8951 20.31 5.27616L17.6718 7.79092L16.7191 6.80508C16.3353 6.40794 15.7022 6.39712 15.3051 6.78091C14.9079 7.16471 14.8971 7.79778 15.2809 8.19492L16.9238 9.89492C17.3057 10.2901 17.935 10.3031 18.3328 9.92385L21.69 6.72385Z",
		fill: "currentColor"
	})]
});
export default SvgPersonApprove;
